module.exports = __webpack_public_path__ + "static/img/tab-one-active.0e25eeb7.png";